<main class="c-main" role="main">
    <div class="c-page-other2confirm">
      <div class="container">
        <div class="row mobile--orange u-pt30 u-pb30">
          <div class="col-md-12">
            <h2 class="o-title js-txt3">{{'ConfirmationPublic.title' | translate}}</h2>
          </div>
        </div>
      </div>
      <section class="c-results">
        <div class="container u-pt40 u-pb60">
          <div class="row">
            <div class="col-md-10 col-md-offset-1" *ngIf="success==='success'">
              <h2 class="o-title o-title--medium o-title--center js-txt4">{{'ConfirmationPublic.bodySuccess' | translate}}</h2>
              <div class="o-steps">
                <div class="row">
                  <div class="col-md-10 col-md-offset-1">
                    <div class="row">
                      <div class="col-xs-6 col-xs-offset-3 o-steps__step o-steps__step--single o-steps__step--approved">
                        <div   class="o-steps__circle"><i class="icon icon-check"></i></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-10 col-md-offset-1" *ngIf="success==='fail'">
              <h2 class="o-title o-title--medium o-title--center js-txt4">{{'ConfirmationPublic.bodyFailed' | translate}}</h2>
              <div class="o-steps">
                <div class="row">
                  <div class="col-md-10 col-md-offset-1">
                    <div class="row">
                      <div  class="col-xs-6 col-xs-offset-3 o-steps__step o-steps__step--rejected">
                        <div  class="o-steps__circle"><i class="icon icon-close"></i></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </main>